<template>
  <div id="editTestPaper">
    <div class="title">
      <h3>{{ PagerId ? '编辑' : '新增' }}评审细则</h3>
    </div>
    <div class="content">
      <el-form :rules="rules" ref="ruleForm" size="small" :model="form" label-position="top">
        <el-form-item label="评审细则名称" prop="name">
          <el-input style="width: 40%; min-width: 280px" v-model="form.name" placeholder="请输入评审细则名称"></el-input>
        </el-form-item>
        <el-form-item label="配置题目" required>
          <el-tree
            v-if="questionList && questionList.length"
            class="PagerTree"
            :data="questionList"
            show-checkbox
            ref="tree"
            node-key="id"
            :default-expanded-keys="defaultExpandedKeys"
            :default-checked-keys="defaultCheckedKeys"
            :props="defaultProps"
            @check="getCheckedNodes">
            <span class="custom-tree-node" slot-scope="{ node, data }">
              <span :class="{ fonstw: data.tier == 1 }">
                <span style="font-weight: 600" v-if="data.index">{{ data.index }}、</span>{{ node.label }}（{{ data.score }}分）
              </span>
            </span>
          </el-tree>
          <div v-else style="text-align: center">
            <img src="../../assets/img/emptyData.png" alt="" />
          </div>
        </el-form-item>
      </el-form>
    </div>
    <div class="quesBtnGuop">
      <div class="row">
        <span>评审细则总分：{{ form.score || '--' }}分</span>
      </div>
      <div class="row" style="margin: 0 0 10px 0">
        <span v-for="(item, index) in form.questions" :key="`${index}a`" v-show="item.tier == 1"> {{ item.name }}：{{ item.score }}分</span>
      </div>
      <div>
        <el-button :loading="loading" @click="handleSave" size="small" style="width: 100px" type="primary">保 存</el-button>
        <el-button @click="common.returnBtn" size="small" style="width: 100px" plain>返 回</el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'editTestPaper',
  components: {},
  data() {
    return {
      PagerId: this.$route.query.id,
      testPapeList: [],
      // 题库列表
      questionList: [],
      defaultCheckedKeys: [], // 默认选中
      defaultExpandedKeys: [], // 默认展开
      defaultProps: { children: 'questionBankList', label: 'name' },
      form: {
        name: '', // 名称
        score: 0, // 总分数
        questions: [], // 问题列表
      },
      rules: {
        name: [{ required: true, message: '请输入评审细则名称', trigger: 'blur' }],
      },
      selectedNodes: [],
      loading: false,
    };
  },
  watch: {},
  created() {
    this.getQuestionList();
  },
  mounted() {
    if (this.PagerId) {
      this.getExaminationInfo(this.PagerId);
    }
  },
  computed: {
    currentUser: function () {
      return this.$store.getters.getCurrentUser;
    },
  },
  methods: {
    // 获取题库列表
    getQuestionList() {
      this.$axios.post('api/question/questionList').then((res) => {
        if (res.data.code == 200) {
          this.questionList = res.data.data || [];
          this.defaultExpandedKeys = this.filterByTier(this.questionList).map((e) => e.id);
          this.$nextTick(() => {
            const selectedNodes = this.$refs.tree.getCheckedNodes(false, true);
            if (selectedNodes && selectedNodes.length) {
              this.calculateScore(selectedNodes);
            }
          });
        }
      });
    },
    // 获取详情回显内容
    getExaminationInfo(id) {
      this.$axios.post('api/examination/examinationInfo', { id }).then((res) => {
        if (res.data.code == 200) {
          this.form.score = res.data.data.score;
          this.form.name = res.data.data.name;
          this.defaultCheckedKeys = this.getLastIds(res.data.data.questionList);
          console.log('🚀 ~ this.defaultCheckedKeys:', this.defaultCheckedKeys);
          // 加延迟是因为 tree 的渲染慢导致获取 getCheckedNodes 会报错
          setTimeout(() => {
            this.$nextTick(() => {
              const selectedNodes = this.$refs.tree.getCheckedNodes(false, true);
              if (selectedNodes && selectedNodes.length) {
                this.calculateScore(selectedNodes);
              }
            });
          }, 100);
        }
      });
    },

    handleSave() {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          // 1. 是否只是叶子节点，默认值为 false 2. 是否包含半选节点，默认值为 false
          // 获取 选中的 节点
          const selectedNodes = this.$refs.tree.getCheckedNodes(false, true);
          if (selectedNodes && selectedNodes.length) {
            this.calculateScore(selectedNodes);
            this.PagerId ? this.$set(this.form, 'id', this.PagerId) : '';
            this.loading = true;
            this.$axios.post('api/examination/addExamination', this.form).then((res) => {
              if (res.data.code == 200) {
                this.$message({
                  message: `${this.PagerId ? '编辑' : '新增'}成功`,
                  type: 'success',
                  offset: 80,
                });
                this.loading = false;
                this.common.returnBtn();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: 'error',
                  offset: 80,
                });
                this.loading = false;
              }
            });
          } else {
            this.$message({
              message: '请选择题目',
              type: 'warning',
              offset: 80,
            });
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    getCheckedNodes() {
      this.$nextTick(() => {
        const selectedNodes = this.$refs.tree.getCheckedNodes(false, true);
        if (selectedNodes && selectedNodes.length) {
          this.calculateScore(selectedNodes);
        }
      });
    },
    // 计算分数
    calculateScore(selectedNodes) {
      // 克隆一份数据，避免 重新计算分数时影响原来分数
      const newSelectedNodes = JSON.parse(JSON.stringify(selectedNodes));
      // 循环 计算新的分数，这里可能会浪费性能，目前没有好的办法
      newSelectedNodes.forEach((e) => {
        this.calculateScores(newSelectedNodes);
      });
      // 去除 每一项里面的子集，没有用，以免传给后台 数据量庞大问题
      newSelectedNodes.forEach((e) => {
        delete e.questionBankList;
      });
      console.log('🚀 ~ newSelectedNodes:', newSelectedNodes);

      this.form.questions = newSelectedNodes;
      console.log('🚀 ~ this.form.questions:', this.form.questions);
      // 计算总分数，只需要把 1 级的分数加起来就可以了
      this.form.score = newSelectedNodes.reduce((acc, curr) => {
        if (curr.tier === 1) {
          return acc + curr.score;
        }
        return acc;
      }, 0);
    },
    // 重新计算分数的辅助方法
    calculateScores(data) {
      if (!data || !Array.isArray(data)) {
        return [];
      }
      const scoresMap = {};
      data.forEach((item) => {
        scoresMap[item.id] = item.score;
      });
      data.forEach((item) => {
        if (item.questionBankList && item.questionBankList.length) {
          const children = data.filter((child) => child.parentId === item.id);
          item.score = children.reduce((acc, child) => acc + scoresMap[child.id], 0);
        }
      });
      return data;
    },
    // 计算 默认展开的层级 id 和 计算 序号
    filterByTier(data) {
      const result = [];
      let that = this;
      function traverse(arr, parentIndex) {
        arr.forEach((obj, index) => {
          let currentIndex = '';
          if (obj.tier >= 2) {
            currentIndex = parentIndex ? `${parentIndex}.${index + 1}` : `${index + 1}`;
            that.$set(obj, 'index', currentIndex);
          }
          if (obj.tier === 1 || obj.tier === 2) {
            result.push(obj);
          }
          if (obj.questionBankList) {
            traverse(obj.questionBankList, currentIndex);
          }
        });
      }

      traverse(data);
      return result;
    },
    // 定义一个函数用于递归获取最后一级的 id
    getLastIds(questionList, result = []) {
      // 遍历questionList
      questionList.forEach((question) => {
        // 如果当前 question 的 questionBankList 不为空，则递归调用 getLastIds
        if (question.questionBankList && question.questionBankList.length > 0) {
          this.getLastIds(question.questionBankList, result);
        } else {
          // 如果当前 question 的 questionBankList 为空，则将当前 question 的 id 添加到结果数组中
          result.push(question.questionId);
        }
      });
      // 返回结果数组
      return result;
    },
  },
};
</script>

<style lang="less" scoped>
#editTestPaper {
  .title {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .content {
    // background-color: aqua;
    padding: 15px 0;
    box-sizing: border-box;
    height: calc(100% - 120px);
    overflow: auto;
  }
  .quesBtnGuop {
    width: 100%;
    height: 110px;
    left: 0;
    position: absolute;
    box-sizing: border-box;
    padding: 0 20px;
    bottom: 0;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    box-shadow: 0px -4px 8px 0px rgba(0, 0, 69, 0.05);
    .row {
      color: rgba(80, 88, 105, 1);
      font-size: 13px;
      margin: 10px 0;
      span {
        margin-right: 25px;
      }
    }
  }
}
// 树的样式
.PagerTree {
  background-color: rgba(80, 88, 105, 0.06);
  padding: 15px 0;
  /deep/ .el-tree-node__content {
    height: 30px;
    .fonstw {
      font-weight: 600;
      font-size: 16px;
    }
  }
}

/deep/ .el-form-item__label {
  padding-bottom: 0;
}
/deep/ .el-form-item {
  margin-bottom: 8px;
}
</style>

<style lang="less" scoped>
/* PC端样式 */
@media only screen and (min-width: calc(700px + 1px)) {
}

/* 移动端样式 */
@media only screen and (max-width: 700px) {
}
</style>
